import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import Diagnosis from './pages/Diagnosis.vue';
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.surveyId = 0;
        _this.liffId = '';
        return _this;
    }
    App.prototype.created = function () {
        console.log("App created start");
        var element = document.getElementById('templat_key');
        if (element) {
            // WordPress組み込み
            this.$store.commit('setAppType', 'WORDPRESS');
            this.surveyId = Number(element.innerText);
        }
        else {
            // LINE LIFFアプリ
            this.$store.commit('setAppType', 'LINE');
            this.surveyId = Number(this.getParam('sid'));
            this.liffId = this.getParam('lid');
            // console.log(`survey id = ${this.surveyId} liff id = ${this.liffId}`)
            // alert(`survey id = ${this.surveyId} liff id = ${this.liffId}`)
        }
    };
    App.prototype.getParam = function (name) {
        var url = window.location.href;
        // name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
        if (!results)
            return null;
        if (!results[2])
            return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    };
    App = __decorate([
        Component({
            components: { Diagnosis: Diagnosis }
        })
    ], App);
    return App;
}(Vue));
export default App;
